import { useApplicationContext } from "components/Application";
import { capitalize } from "lodash";
import React, { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import tw from "twin.macro";

type ListItemProps = {
  item: any;
  brand: any;
  prices: any;
  hideLineIcon?: boolean;
};

export const ListItem: React.FC<ListItemProps> = (props) => {
  const { item, brand, prices, hideLineIcon } = props;
  const {
    siteEnvironment: { appEndpointStore },
  } = useApplicationContext();

  const [active, setActive] = useState(false);

  const { i18n } = useTranslation();
  const languageSuffix = capitalize(i18n.language);

  const sizes = item.sizeGroup?.sizes ?? false;
  const variants = item.variants ?? false;
  const stocks = item.stocks ?? false;

  const capsule = item.kind?.code === "capsule" ?? false;
  let formattedWholesale: string | false = false;
  let formattedWholesalePromo: string | false = false;
  prices.forEach((price: any) => {
    if (price.itemId === item.id) {
      formattedWholesale = price.formattedWholesale;
      formattedWholesalePromo = price.formattedWholesalePromo;
    }
  });

  let someAvailable: boolean = item.available === true;
  item.variants.forEach((variant: any) => {
    if (variant.available === true) someAvailable = true;
  });

  return (
    <Link
      key={item.code}
      to={`/b/${brand.id}/s/${item.season.id}/i/${item.id}`}
      tw="block relative w-full mb-8 cursor-pointer hover:(shadow-xl text-gray-900)"
      onMouseEnter={() => setActive(true)}
      onMouseLeave={() => setActive(false)}
    >
      <img src={`${appEndpointStore}${item.cover}`} alt={item[`name${languageSuffix}`]} />
      {item.line && !hideLineIcon && (
        <svg
          viewBox="0 0 13 34"
          tw="absolute"
          style={{ height: "32px", left: "8px", top: 0, color: `#${item.line.color}` }}
        >
          <path d="M13 0H0V34L6.5 27.5L13 34V0Z" fill="currentColor" />
        </svg>
      )}
      {formattedWholesalePromo && (
        <div
          tw="absolute"
          style={{
            right: "8px",
            top: "8px",
            backgroundColor: "#ffc043",
            borderRadius: "30px",
            padding: "5px",
          }}
        >
          <p style={{ marginBottom: 0, fontSize: "12px", fontWeight: 600 }}>3.0</p>
        </div>
      )}
      {capsule && (
        <div
          tw="absolute"
          style={{
            right: "8px",
            top: "8px",
            backgroundColor: "rgb(221 79 239)",
            color: "#fff",
            borderRadius: "30px",
            padding: "5px",
          }}
        >
          <p style={{ marginBottom: 0, fontSize: "12px", fontWeight: 600 }}>CC</p>
        </div>
      )}
      {someAvailable ? (
        <Fragment>
          {!active && (
            <div tw="text-center p-2">
              {item[`name${languageSuffix}`].toUpperCase()}
              <br />
              {formattedWholesale || "€ 0,00"}
              {formattedWholesalePromo && i18n.language === "it" && ` o ${formattedWholesalePromo}`}
              {formattedWholesalePromo && i18n.language === "en" && ` or ${formattedWholesalePromo}`}
            </div>
          )}
          {active && (
            <div
              css={[
                tw`flex justify-center align-middle space-x-4`,
                item.season?.isStock && tw`pt-6 pb-5`,
                !item.season?.isStock && tw`pt-5`,
              ]}
            >
              {item.season?.isStock
                ? stocks &&
                  stocks.map((stock: any) => (
                    <Fragment key={`${stock.id}${stock.size.code}`}>
                      {stock.quantity > 0 && <p>{stock.size.code}</p>}
                    </Fragment>
                  ))
                : variants && (
                    <Fragment>
                      <span
                        key={`${item.id}${item.color}`}
                        style={{
                          backgroundImage: `url(${appEndpointStore}${item.color?.patch})`,
                          display: "block",
                          width: "20px",
                          height: "20px",
                          backgroundSize: "cover",
                        }}
                      />
                      {variants.map((variant: any) => (
                        <span
                          key={`${variant.id}${variant.color}`}
                          style={{
                            backgroundImage: `url(${appEndpointStore}${variant.color?.patch})`,
                            display: "block",
                            width: "20px",
                            height: "20px",
                            backgroundSize: "cover",
                          }}
                        />
                      ))}
                    </Fragment>
                  )}
              {!sizes && <p>{i18n.language === "it" ? "NON DISPONIBILE" : "NOT AVAILABLE"}</p>}
            </div>
          )}
        </Fragment>
      ) : (
        <div tw="text-center p-2">
          {item[`name${languageSuffix}`].toUpperCase()}
          <br />
          {i18n.language === "it" ? "NON DISPONIBILE" : "NOT AVAILABLE"}
        </div>
      )}
    </Link>
  );
};
